import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { registerAuthNavigate } from '@/config/api/authNavigate'

/** Registers router navigate for axios 401 handling. Mount once inside RouterProvider. */
export default function AuthNavigateRegistrar() {
  const navigate = useNavigate()

  useEffect(() => {
    registerAuthNavigate((to, options) => {
      navigate(to, options)
    })
    return () => registerAuthNavigate(null)
  }, [navigate])

  return null
}
